import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ExerciseSpecificForm from '../../../components/forms/ExerciseSpecificForm';
import { useExerciseSpecificApi } from '../../../hooks/useExerciseSpecificApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { ExerciseSpecificDTO } from '../../../services/apiClient';

const ExerciseSpecificCreate: React.FC = () => {
  const { create, isLoading } = useExerciseSpecificApi();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Exercise Specifics', href: '/admin/exercisespecifics' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: ExerciseSpecificDTO) => {
    try {
      await create(data);
      navigate('/admin/exercisespecifics');
    } catch (error) {
      console.error('Error creating Exercise Specific:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/exercisespecifics"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.ExerciseSpecific.Edit'
    >
        <ExerciseSpecificForm
          initialValues={{} as ExerciseSpecificDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/exercisespecifics')}
        />
    </AdminLayout>
  );
};

export default ExerciseSpecificCreate;